import { cn } from '@/lib/utils';

import { WithRef } from '@/components/types';

type HeaderProps = {
  children: React.ReactNode;
  classNames?: {
    wrapper?: string;
  };
};

const Header = ({
  children,
  classNames,
  ref,
}: WithRef<HTMLDivElement, HeaderProps>) => {
  return (
    <header
      ref={ref}
      className={cn(
        'bg-neutral-N99 light fixed left-0 top-0 z-50 flex h-12 w-full items-center px-5 py-3 md:h-16 md:px-10 md:py-4',
        classNames?.wrapper
      )}
      data-tracker-section='header'
    >
      {children}
    </header>
  );
};

export default Header;
